import axios from '@/utils/miniAxios'
const api = {
    brandDetail: '/api/brands',
    taskList: '/api/tasks'
}

/**
 * 查询品牌详情
 * @returns {Promise<any>}
 */
export function fetchBrandById (id) {
    return new Promise((resolve, reject) => {
        axios.get(api.brandDetail + '/' + id)
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

/**
 * 查询任务列表
 * @returns {Promise<any>}
 */
export function fetchTask (params) {
    return new Promise((resolve, reject) => {
        axios.get(api.taskList, { params })
            .then(response => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
